import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconItalicComponent } from "./med-icon-italic.component";

@NgModule({
  declarations: [
    MedIconItalicComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconItalicComponent,
  ],
})
export class MedIconItalicModule { }
